import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setNews } from "../../../redux/NewsPreviewReducer";
import NewsPreview from "./NewsPreview";

const NewsPreviewContainer = ({ setNews }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await fetch('/api/news');
      if (response.ok) {
        const data = await response.json();
        setNews(data);
      } else {
        console.error('Ошибка при загрузке новостей');
        // Используем пустой массив в случае ошибки
        setNews([]);
      }
    } catch (error) {
      console.error('Ошибка при загрузке новостей:', error);
      // Используем пустой массив в случае ошибки
      setNews([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Загрузка новостей...</div>;
  }

  return <NewsPreview />;
};

export default connect(null, { setNews })(NewsPreviewContainer);
